<style scoped lang="less">
.secondary:before {
    color: #bbbbbb;
}
th .btn {
    font-weight: inherit;
}
.icon-sortable:before {
    color: #bbbbbb;
}
</style>
<template>
    <div class="form-group focus-form-group dropdown-form-group clearfix" :class="[settings.isChild ? 'form-group-child' : null, colClass]">
        <div v-if="allowExportTableData && !allowSelectedExport" class="float-right mb-2"><button class="export-btn btn btn-outline-secondary btn-sm mb-1" @click.prevent="startExport('CSV', 'Export All')">Export to CSV</button></div>
        <div v-if="allowExportTableData && allowSelectedExport" class="float-right mb-2">
            <div class="dropdown btn-group btn-group-sm">
                <button type="button" data-toggle="dropdown" data-trigger="hover" class="export-btn btn btn-outline-secondary btn-sm dropdown-toggle" @click.prevent.stop="toggleDropdown($event)" aria-expanded="false">Export to CSV</button>
                <ul class="dropdown-menu">
                    <li class="nav-item" v-for="(value, key) of exportSchemas">
                        <input type="submit" class="btn btn-bare" @click.prevent="startExport(value.type, value.schema)" name="Action" :value="key" />
                    </li>
                </ul>
            </div>
        </div>
        <table class="table table-responsive-md" v-if="!isViewOnly || showSelectColumn">
            <thead>
                <tr>
                    <th v-if="showSelectColumn"><span class="sr-only">Select</span></th>
                    <th v-if="showIndexColumn && !isViewOnly"><span aria-hidden="true">#</span><span class="sr-only">Column Index</span></th>
                    <th :id="vmId + 'S' + columnIndex" v-for="(column, columnIndex) in settings.tableColumns">
                        <button type="button" class="sort-btn btn btn-bare p-0" @click.prevent="toggleSort(column.datasourceColumn, $event)" role="radio" :aria-checked="sortDir(column.datasourceColumn) !== null" :aria-label="`${stringCoalesce(column.displayLabel, column.datasourceColumn)}: ${sortDir(column.datasourceColumn) === null ? 'Unsorted' : 'Sorted ' + sortDirDisplay(column.datasourceColumn)}`" :aria-sort="sortDirDisplay(column.datasourceColumn)">
                            {{ stringCoalesce(column.displayLabel, column.datasourceColumn) }}
                            <span class="icon" :class="sortIcon[sortDir(column.datasourceColumn)]"></span>
                            <!--
                        {{ sortDirDisplay(column.datasourceColumn) }}
                        --></button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-if="isViewOnly">
                    <tr v-for="(row, rowIndex) in data.selectedRows" tabindex="0" :aria-label="generateAriaLabel(row, rowIndex)">
                        <td>
                            <input :type="selectMultiple ? 'checkbox' : 'radio'" checked disabled />
                        </td>
                        <!--
                    <td v-if="showIndexColumn">{{ rowIndex + 1 }}</td>
                    -->
                        <td v-for="(cell, cellIndex) in row">
                            <template v-if="settings.tableColumns[cellIndex].displayType == ColumnDisplayType.Html">
                                <div v-html="cell"></div>
                            </template>
                            <template v-else>
                                {{ cell }}
                            </template>
                        </td>
                    </tr>
                </template>
                <tr v-else-if="rows == null || (rows.length == 0 && inputEffectiveDiffer)">
                    <td :colspan="(showSelectColumn ? 1 : 0) + (showIndexColumn ? 1 : 0) + settings.tableColumns.length" class="text-center">
                        <LoadingWheel width="64" />
                    </td>
                </tr>
                <template v-else>
                    <tr v-for="(row, rowIndex) in rows" :id="vmId + 'R' + rowIndex" :class="{ 'table-active': selectMultiple ? selected.includes(rowIndex) : selected == rowIndex }" :tabindex="!showSelectColumn ? 0 : undefined" :aria-label="generateAriaLabel(row, rowIndex)">
                        <td v-if="inputEffectiveDiffer" :colspan="(showSelectColumn ? 1 : 0) + (showIndexColumn ? 1 : 0) + settings.tableColumns.length" class="text-center"><LoadingWheel width="16" class="d-inline-block" /> Loading...</td>
                        <template v-else>
                            <td v-if="showSelectColumn" role="presentation">
                                <label :for="vmId + 'selector' + rowIndex" :aria-labelledby="vmId + 'R' + rowIndex">
                                    <input :type="selectMultiple ? 'checkbox' : 'radio'" v-model="selected" :id="vmId + 'selector' + rowIndex" :name="vmId + 'selector'" :value="rowIndex" />
                                </label>
                            </td>
                            <td v-if="showIndexColumn" role="presentation">{{ effectiveSkip + rowIndex + 1 }}<span class="sr-only">, </span></td>
                            <td v-for="key in settings.tableColumns" role="presentation">
                                <template v-if="key.displayType == ColumnDisplayType.Html">
                                    <div v-html="row[key.datasourceColumn]"></div>
                                </template>
                                <template v-else>
                                    {{ row[key.datasourceColumn] }}
                                </template>
                            </td>
                        </template>
                    </tr>
                </template>
            </tbody>
            <tfoot v-if="!isViewOnly && rows != null">
                <tr v-if="rowsCount > (settings.defaultPageSize || 5)">
                    <td :colspan="(showSelectColumn ? 1 : 0) + (showIndexColumn ? 1 : 0) + settings.tableColumns.length">
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <button class="btn btn-sm btn-outline-secondary" type="button" :id="vmId + 'B'" @click.prevent="back" :disabled="skip <= 0">Back</button>
                                &nbsp;
                                <label :for="vmId + 'P'" class="mb-0 ml-1">Page:</label>
                                &nbsp;
                                <select :id="vmId + 'P'" v-model="skip" class="form-control form-control-sm w-auto d-inline px-0 mx-1 text-center">
                                    <option v-for="i of pageOptions" :value="i.value">{{ i.label }}</option>
                                </select>
                                / {{ pages }}
                                &nbsp;
                                <button class="btn btn-sm btn-outline-secondary" type="button" :id="vmId + 'N'" @click.prevent="next" :disabled="skip + top >= rowsCount">Next</button>
                            </div>
                            <div class="d-flex align-items-center ml-auto pl-5">
                                <label :for="vmId + 'PS'" class="mb-0">Page Size:</label>
                                <select :id="vmId + 'PS'" v-model="top" class="form-control form-control-sm w-auto d-inline px-0 ml-2 text-center">
                                    <option :value="5">5</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
        <ErrorList :data="data" />
        <Comments :data="data" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
const MULTIPLE_COLUMN_SORT = false;
import { defineComponent, ref, watch, computed, nextTick } from "vue";
import { SelectionType } from "@cs/SelectionType";
import { ColumnDisplayType } from "@cs/ColumnDisplayType";
import { isNullOrWhitespace, stringCoalesce } from "@/lib/whitespaceMethods";
import { switchMap, map } from "rxjs/operators";
import { useMainStore } from "@/mainStore";
import { useObservable, from } from "@vueuse/rxjs";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import type DataTableDef from "../elements/DataTableDef";
import type { DataTableSettings } from "@cs-ts/data-table-settings";
import { fromWithCurrent } from "@/lib/observableHelpers";
import { BuiltinExportSchemas } from "@cs/BuiltinExportSchemas";
import { throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { KeyValue } from "@cs/KeyValue";
import { toggleDropdown } from "@/lib/toggleDropdown.3";

const sortIcon = {
    null: "icon-sortable",
    "asc primary": "icon-ascend",
    "desc primary": "icon-descend",
    "asc secondary": "icon-ascend secondary",
    "desc secondary": "icon-descend secondary",
};
const exportSchemas = Object.entries(BuiltinExportSchemas.MAP).reduce(
    (a, [k, v]) => {
        const l = v == "" ? "Export All" : "Export Selected";
        a[l] = { type: "CSV", schema: l };
        return a;
    },
    {} as Record<string, { type: string; schema: string }>,
);
interface NavigatorWithMsSaveOrOpenBlob extends Navigator {
    msSaveOrOpenBlob?: (blob: Blob, filename?: string) => boolean;
}
export default defineComponent({
    components: {
        LoadingWheel,
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<DataTableDef, DataTableSettings>) {
        const base = setup<DataTableDef, DataTableSettings>(props);
        const skip = ref(0);
        const top = ref(5);
        const sort = ref([] as [string, string][]);
        const inited = ref(false);
        const updating = ref(false);
        const exportRowData = ref([] as KeyValue[][]);
        const mainStore = useMainStore();

        const rowsData = useObservable(
            //@ts-ignore VUE2 issue?
            from<boolean>(inited).pipe(
                switchMap(i => {
                    if (!i) return from([{ data: {}, dataCount: 0 }]) as ReturnType<typeof props.data.rows$>;
                    return props.data.rows$(fromWithCurrent(skip), fromWithCurrent(top), fromWithCurrent(sort));
                }),
                map(i => {
                    return {
                        ...i,
                        skip: skip.value,
                        top: top.value,
                        sort: sort.value,
                    };
                }),
            ),
        );
        if (props.data.definition.settings.dataSourceCalculationId != null) {
            const filterData = useObservable(props.data.resolveCalculation(props.data.definition.settings.dataSourceCalculationId));
            watch(
                () => filterData.value,
                () => {
                    const skipCeil = Math.ceil((skip.value ?? 0) / top.value);
                    if (pages.value <= skipCeil && pages.value > 0) {
                        skip.value = (pages.value - 1) * top.value;
                    }
                },
            );
        }

        const allowExportTableData = computed(() => {
            return props.data.definition.settings.allowExport ?? true;
        });

        const selected = computed({
            get() {
                const result = [];
                const keys = props.data.definition.settings.tableColumns.map(i => i.datasourceColumn!);
                const dataRows = rows.value ?? [];
                const selectedRows = props.data.selectedRows;
                for (const selectedRow of selectedRows ?? []) {
                    for (let r = 0; r < dataRows.length; r++) {
                        if (keys.every((k, i) => selectedRow[i] == dataRows[r][k])) {
                            result.push((effectiveSkip.value ?? 0) + r);
                        }
                    }
                }
                const boundResult = result.filter(i => i < (effectiveSkip.value ?? 0) + (effectiveTop.value ?? 0) && i >= (effectiveSkip.value ?? 0)).map(i => i - (effectiveSkip.value ?? 0));
                if (selectMultiple.value) {
                    return boundResult;
                } else {
                    return boundResult.length ? boundResult[0] : null;
                }
            },
            set(newValue) {
                if (updating.value) return;
                const keys = props.data.definition.settings.tableColumns.map(i => i.datasourceColumn!);
                const dataRows = rows.value ?? [];
                if (selectMultiple.value) {
                    const match = (dataRow: Record<string, string>, selectedRow: string[]) => keys.every((k, i) => dataRow[k] == selectedRow[i]);
                    const selectedRows = props.data.selectedRows as string[][];
                    const add = (newValue as number[]).map(i => dataRows[i]);
                    const remove = dataRows.filter(i => !add.some(j => i == j));
                    const consider = selectedRows.slice();
                    const add2 = add.filter(d => selectedRows.every(s => !match(d, s))).map(i => keys.map(k => i[k]));
                    const result = consider.filter(s => !remove.some(d => match(d, s))).concat(add2);
                    props.data.setSelectedRows(result);

                    const filterExportData = (row: KeyValue[]) => row.filter(i => keys.includes(i.Key)).map(i => i.Value);
                    const considerExport = exportRowData.value.slice();
                    const exportAdd2 = add.filter(d => selectedRows.every(s => !match(d, s))).map(i => Object.keys(i).map(j => ({ Key: j, Value: i[j] })));
                    exportRowData.value = considerExport.filter(s => !remove.some(d => match(d, filterExportData(s)))).concat(exportAdd2);
                    //debugger;
                } else {
                    const singleSelectedRow = dataRows[newValue as number];
                    props.data.setSelectedRows([keys.map(k => singleSelectedRow[k])]);
                    exportRowData.value = [Object.keys(singleSelectedRow).map(j => ({ Key: j, Value: singleSelectedRow[j] }))];
                }
                nextTick(() => {
                    updating.value = false;
                });
            },
        });
        const showSelectColumn = computed(() => {
            return props.data.definition.settings.selectable != null && props.data.definition.settings.selectable != SelectionType.No;
        });
        const selectMultiple = computed(() => {
            return props.data.definition.settings.selectable != null && props.data.definition.settings.selectable == SelectionType.Multiple;
        });
        const allowSelectedExport = computed(() => {
            return props.data.definition.settings.selectable != null && (props.data.definition.settings.selectable == SelectionType.Multiple || props.data.definition.settings.selectable == SelectionType.Single);
        });
        const showIndexColumn = computed(() => {
            return props.data.definition.settings.showIndexColumn ?? true;
        });
        const rows = computed(() => {
            return rowsData.value?.data;
        });
        const rowsCount = computed(() => {
            return rowsData.value?.dataCount;
        });
        const effectiveSkip = computed(() => {
            return rowsData.value?.skip;
        });
        const effectiveTop = computed(() => {
            return rowsData.value?.top;
        });
        const effectiveSort = computed(() => {
            return rowsData.value?.sort;
        });
        const inputEffectiveDiffer = computed(() => {
            return skip.value != effectiveSkip.value || top.value != effectiveTop.value || sort.value != effectiveSort.value;
        });
        const pages = computed(() => {
            return Math.ceil((rowsCount.value ?? 0) / top.value);
        });
        const pageOptions = computed(() => {
            const result = [];
            for (let i = 0; i < (rowsCount.value ?? 0); i += top.value) {
                result.push({ value: i, label: i / top.value + 1 });
            }
            return result;
        });
        const next = () => {
            skip.value += top.value;
        };
        const back = () => {
            skip.value = skip.value > top.value ? skip.value - top.value : 0;
        };
        const toggleSort = (column: string, event: Event) => {
            let match = sort.value.find(i => i[0] == column);
            if (match == null) {
                match = [column, "asc"];
            } else {
                match[1] = match[1] == "asc" ? "desc" : "asc";
            }
            if (MULTIPLE_COLUMN_SORT) {
                sort.value = [match, ...sort.value.filter(i => i != match)];
            } else {
                sort.value = [match];
            }
        };
        const sortDirDisplay = (column: string) => {
            const sortDirI = sortDir(column);
            return sortDirI == null ? "none" : sortDirI.includes("asc") ? "ascending" : "descending";
        };
        const sortDir = (column: string) => {
            let match = sort.value.find(i => i[0] == column);
            if (match == null) {
                return null;
            } else {
                const mode = match == sort.value[0] ? "primary" : "secondary";
                return `${match[1]} ${mode}`;
            }
        };
        const generateAriaLabel = (row: Record<string, string>, index: number) => {
            const result = [];
            result.push(`${showSelectColumn.value ? "Select" : ""} Row ${index + 1}`);
            const hasIndexColumn = !base.isViewOnly.value && showIndexColumn.value;
            if (hasIndexColumn) {
                result.push(`Column 1 - Column Index: ${(effectiveSkip.value ?? 0) + index + 1}`);
            }
            result.push(props.data.definition.settings.tableColumns.map((column, columnIndex) => `Column ${columnIndex + (hasIndexColumn ? 1 : 0) + 1} - ${column.displayLabel ?? column.datasourceColumn}: ${row[column.datasourceColumn!] ?? row[columnIndex]}`).join(", "));
            return result.join(", ").trim();
        };
        const startExport = async (exportFormat: string, exportType: string) => {
            return _runExport("ExportDataTable", exportFormat, exportType);
        };
        const _runExport = async (action: string, exportFormat: string, exportType: string) => {
            const handleFileResponse = async (fileResponse: Response) => {
                let filename = "dataTable.csv";
                const disposition = fileResponse.headers.get("content-disposition");
                const blob = await fileResponse.blob();
                // https://stackoverflow.com/a/40940790
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                // https://stackoverflow.com/a/48968694
                const windowNavigator: NavigatorWithMsSaveOrOpenBlob = window.navigator;
                if (windowNavigator.msSaveOrOpenBlob) {
                    windowNavigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }, 0);
                }
            };

            const result = await props.data.exportRows(exportRowData.value, exportType);
            if (result?.Success == true) {
                const fetchUrl = await mainStore.getUrl("dataTableExportFetch", { token: result.Token });
                const fetchResponse = await fetch(fetchUrl, {
                    method: "GET",
                    credentials: "same-origin",
                });
                throwIfNonSuccessStatus(fetchResponse);
                handleFileResponse(fetchResponse);
            }
        };
        if (!isNullOrWhitespace(props.data.definition.settings.defaultSort)) {
            sort.value = [[props.data.definition.settings.defaultSort!, "asc"]];
        }
        if (!isNullOrWhitespace(props.data.definition.settings.defaultPageSize?.toString())) {
            // eslint-disable-next-line vue/no-setup-props-destructure
            top.value = props.data.definition.settings.defaultPageSize!;
        }
        inited.value = true;

        watch(
            () => sort.value,
            () => {
                skip.value = 0;
            },
        );

        watch(
            () => top.value,
            newTop => {
                skip.value -= skip.value % newTop; // adjust skip to an skip option that exists
            },
        );

        return {
            // "constants"
            ColumnDisplayType,
            stringCoalesce,
            sortIcon,
            exportSchemas,
            skip,
            top,

            rows,
            rowsCount,
            selected,
            showSelectColumn,
            showIndexColumn,
            selectMultiple,
            allowSelectedExport,
            effectiveSkip,
            inputEffectiveDiffer,
            pages,
            pageOptions,

            next,
            back,
            toggleSort,
            sortDirDisplay,
            sortDir,
            startExport,
            allowExportTableData,
            toggleDropdown,
            generateAriaLabel,

            ...base.expose,
        };
    },
});
</script>
